import { ETAPAS_EXECUCAO_CIMENTO, ETAPAS_SISTEMA_CIMENTO } from "./tutoriaisCimento";

const passosSistema = (nome) => [
  { preview: "ensaio-sistema:0", titulo: `Lista de ${nome}`, descricao: "Conheça os registros, a pesquisa, os filtros, a paginação e as ações disponíveis nesta tela." },
  { preview: "ensaio-sistema:1", titulo: "Novo cadastro", descricao: "Inicie um novo registro, selecione cliente, obra e materiais e preencha os dados gerais solicitados." },
  { preview: "ensaio-sistema:2", titulo: "Lançamento dos resultados", descricao: "Abra o cadastro salvo, registre leituras, cálculos e observações e salve antes de sair." },
  { preview: "ensaio-sistema:3", titulo: "Relatório e histórico", descricao: "Revise os resultados, visualize ou imprima o relatório e consulte revisões ou histórico quando disponíveis." },
];

const passoExecucao = (familia, painel, titulo, descricao, dicas = []) => ({
  preview: `${familia}-execucao:${painel}`,
  titulo,
  descricao,
  dicas,
});

const ETAPAS_SISTEMA_AGENDA = [
  {
    preview: "agenda:0",
    titulo: "Localize a obra na Agenda",
    descricao: "Na tela Agenda de Moldagem e Ruptura, pesquise pelo nome da obra e use o filtro para alternar entre relatórios cadastrados e demais situações disponíveis. Clique no nome da obra para consultar suas moldagens ou em Gerar relatório para emitir o consolidado correspondente.",
    dicas: [
      "Confirme cliente e obra antes de iniciar: esses dados identificam todos os registros e relatórios posteriores.",
      "A data de última alteração ajuda a verificar se a agenda recebeu lançamentos recentes.",
      "Use Cadastrar Moldagem para um novo recebimento de concreto; não reutilize uma moldagem antiga.",
    ],
  },
  {
    preview: "agenda:1",
    titulo: "Consulte as moldagens da obra",
    descricao: "Após abrir a obra, pesquise moldagens por data de moldagem, data de ruptura, moldador, nota/romaneio ou peça concretada. Cada cartão informa a data, o moldador e a quantidade de caminhões e oferece ações para visualizar, imprimir, editar e consultar o histórico.",
    dicas: [
      "Use a visualização para conferir os dados sem liberar campos para edição.",
      "Use Editar somente quando precisar corrigir ou complementar informações e salve as alterações ao final.",
      "Consulte o histórico para preservar a rastreabilidade de correções realizadas no registro.",
    ],
  },
  {
    preview: "agenda:2",
    titulo: "Cadastre a identificação da moldagem",
    descricao: "Clique em Cadastrar Moldagem, selecione cliente e obra, informe a data e identifique o responsável pela produção do concreto. Indique quem executou a moldagem, informe o moldador ou marque N/I somente quando o dado realmente não estiver disponível.",
    dicas: [
      "Selecione uma concreteira cadastrada ou digite o responsável quando o concreto for produzido na obra.",
      "Marque Ruptura externa apenas quando os resultados forem fornecidos pelo cliente; nessa condição, a prensa interna não será vinculada.",
      "Preencha traço, fck de projeto, slump de projeto e tolerância; use N/I individualmente apenas para dados desconhecidos.",
    ],
  },
  {
    preview: "agenda:3",
    titulo: "Configure corpos de prova e idades",
    descricao: "Defina o tipo e a área do corpo de prova, o capeamento, o tipo de descarga, a quantidade de caminhões e as idades de ensaio. Para corpos de prova 10 × 20 cm, o sistema utiliza a área cadastrada; use área personalizada somente quando a geometria exigir.",
    dicas: [
      "Cadastre cada idade prevista em dias; elas organizam a agenda de ruptura e as colunas do relatório.",
      "Revise a quantidade de caminhões antes de salvar, pois ela determina as linhas de lançamento.",
      "Use Salvar e abrir para criar a moldagem e seguir diretamente para o controle de concretagem.",
    ],
  },
  {
    preview: "agenda:4",
    titulo: "Lance e revise os resultados",
    descricao: "No controle de concretagem, confira o cabeçalho e registre por caminhão o código, nota/romaneio, volume, slump medido, resultados nas idades, peça concretada e observações. No modo de edição, altere somente os campos necessários e clique em Salvar Alterações.",
    dicas: [
      "A resistência deve corresponder ao corpo de prova e à idade indicados na coluna.",
      "Registre a peça concretada de forma que seja possível relacionar o resultado ao elemento da obra.",
      "Use a observação do relatório para condições, desvios ou informações relevantes que não cabem na linha do caminhão.",
      "Antes de sair, confira unidades: volume em m³, abatimento em mm, carga em tonelada quando apresentada e resistência em MPa.",
    ],
  },
  {
    preview: "agenda:5",
    titulo: "Emita e confira o relatório",
    descricao: "Abra a visualização de impressão e confira identificação, responsável pela produção, responsável pela moldagem, dados do concreto, datas, resultados, peça e observações. Somente depois dessa conferência utilize Imprimir ou gere o relatório consolidado da obra.",
    dicas: [
      "Verifique se a marcação do responsável pela moldagem corresponde ao cadastro.",
      "Confirme que códigos, datas e resultados do relatório coincidem com os registros de campo e da prensa.",
      "Se houver correção, volte ao cadastro, edite, salve e gere novamente o relatório para manter a versão atualizada.",
    ],
  },
];

const ETAPAS_EXECUCAO_AGENDA = [
  passoExecucao("concreto", 0, "Planejamento e rastreabilidade", "Antes do recebimento, confirme obra, elemento a concretar, fck e consistência especificados, plano de amostragem, número de exemplares, idades de ruptura e equipamentos disponíveis.", [
    "Use equipamentos identificados, verificados e com calibração válida conforme o procedimento do laboratório.",
    "Prepare etiquetas, moldes limpos, base rígida, utensílios de adensamento, recipiente de amostragem e proteção para a cura inicial.",
    "Defina previamente como cada caminhão, amostra e corpo de prova será relacionado ao código lançado no sistema.",
  ]),
  passoExecucao("concreto", 0, "Amostragem do concreto fresco — NBR 16886", "Colete e prepare uma amostra representativa do concreto fresco destinada ao ensaio de consistência e à moldagem, preservando sua homogeneidade e evitando contaminação, perda de pasta ou alteração indevida de umidade.", [
    "Registre obra, data, horário, nota/romaneio, caminhão, volume e peça concretada.",
    "A amostra deve representar o concreto efetivamente lançado; siga os pontos e intervalos de coleta definidos na edição vigente da norma e no procedimento interno.",
    "Homogeneíze a amostra antes de separar as porções para abatimento e moldagem e execute as operações dentro dos tempos controlados pelo procedimento.",
  ]),
  passoExecucao("concreto", 1, "Consistência pelo abatimento — NBR 16889", "Execute o abatimento sobre base adequada, com molde e haste limpos e umedecidos, preenchendo, adensando e retirando o molde conforme o método normativo. Meça o abatimento e compare-o com o valor de projeto e sua tolerância.", [
    "Mantenha o conjunto estável e nivelado e retire o molde verticalmente, sem movimentos laterais que alterem o resultado.",
    "Observe a forma do concreto após a retirada; quando o comportamento invalidar a determinação, trate-o conforme a norma e registre a ocorrência.",
    "Lance no sistema o valor medido em milímetros, separado do slump de projeto exibido no cabeçalho.",
  ]),
  passoExecucao("concreto", 2, "Moldagem dos corpos de prova — NBR 5738", "Confira moldes, dimensões e identificação; preencha e adense os corpos de prova pelo procedimento aplicável à consistência e ao tamanho do molde, faça o acabamento e mantenha cada exemplar vinculado à amostra e à idade programada.", [
    "Evite segregação, perda de material, inclusão excessiva de ar e golpes que deformem ou desloquem o molde.",
    "Identifique sem danificar a superfície e registre moldador, quantidade de corpos de prova, código, data e hora da moldagem.",
    "Proteja imediatamente contra vibração, impacto, insolação, chuva e perda de umidade durante o período inicial.",
  ]),
  passoExecucao("concreto", 3, "Cura, transporte e armazenamento — NBR 5738", "Mantenha os corpos de prova nas condições de cura inicial previstas, desmolde no período aplicável e transfira-os para a cura controlada, preservando identificação e integridade até a idade de ensaio.", [
    "Registre desvios de temperatura, umidade, tempo, transporte ou danos que possam influenciar o resultado.",
    "Durante o transporte, proteja contra impactos, vibrações e perda de umidade.",
    "Organize o tanque ou câmara de modo que a identificação permaneça legível e os corpos de prova recebam condicionamento uniforme.",
  ]),
  passoExecucao("concreto", 4, "Compressão axial — NBR 5739", "Na idade programada, identifique o corpo de prova, verifique dimensões e condição das faces, prepare a superfície de carregamento pelo método cadastrado, centralize-o na prensa e aplique o carregamento conforme o método normativo até a ruptura.", [
    "Confirme se a prensa e os dispositivos usados são compatíveis com a faixa de força e possuem calibração válida.",
    "Não ensaie um corpo de prova cuja identidade, idade ou correspondência com a moldagem esteja duvidosa sem tratar a ocorrência.",
    "Registre carga máxima, resistência calculada, forma de ruptura e qualquer anomalia observada.",
  ]),
  passoExecucao("concreto", 4, "Cálculo, análise e registro", "Calcule a resistência pela carga máxima dividida pela área resistente cadastrada, aplique os critérios previstos pelo método e registre o resultado em MPa na idade correta. Revise o conjunto antes de emitir o relatório.", [
    "Para CP 10 × 20 cm, confirme a área de 7 854 mm² cadastrada; para outra dimensão, utilize a área efetivamente aplicável.",
    "Não troque valores entre corpos de prova ou idades; confira código, data de moldagem e data de ruptura.",
    "Resultados externos devem ser identificados como tal e rastreados ao documento recebido do cliente.",
    "A aceitação do concreto deve seguir a NBR 12655, a especificação do projeto e o procedimento aprovado; o resultado isolado não substitui a avaliação do lote.",
  ]),
];

const catalogo = [
  {
    id: "cimento-pega",
    teste: /^\/app\/cimento-consistencia-pega(?:\/|$)/,
    titulo: "Consistência normal e tempos de pega",
    normas: "ABNT NBR 16606:2018 e ABNT NBR 16607:2018",
    sistema: ETAPAS_SISTEMA_CIMENTO,
    execucao: ETAPAS_EXECUCAO_CIMENTO,
  },
  {
    id: "agenda-ruptura",
    teste: /^\/app\/agendamoldagem(?:\/|$)/,
    titulo: "Moldagem, abatimento e ruptura do concreto",
    normas: "ABNT NBR 16886:2020, NBR 16889:2020, NBR 5738:2015, NBR 5739:2018 e NBR 12655:2022",
    sistema: ETAPAS_SISTEMA_AGENDA,
    execucao: ETAPAS_EXECUCAO_AGENDA,
  },
  {
    id: "extracoes",
    teste: /^\/app\/extracoes-testemunhos(?:\/|$)/,
    titulo: "Extração e ensaio de testemunhos de concreto",
    normas: "ABNT NBR 7680-1 e NBR 5739",
    sistema: passosSistema("extrações de testemunhos"),
    execucao: [
      passoExecucao("extracoes", 0, "Planejamento da extração", "Defina os pontos, verifique armaduras e fixe a extratora perpendicularmente ao elemento."),
      passoExecucao("extracoes", 1, "Extração e identificação", "Extraia sem impactos, identifique orientação e localização e preserve o testemunho contra danos e perda de umidade."),
      passoExecucao("extracoes", 2, "Medição e preparo", "Meça diâmetro e comprimento, registre anomalias e prepare as faces conforme o método aplicável."),
      passoExecucao("extracoes", 3, "Compressão e correções", "Centralize o testemunho, aplique a carga controlada e registre resistência, tipo de ruptura e fatores de correção aplicáveis."),
    ],
  },
  {
    id: "modulo-elasticidade",
    teste: /^\/app\/(?:modulo-elasticidade|relatorios\/modulo-elasticidade)(?:\/|$)/,
    titulo: "Módulo de elasticidade dinâmico",
    normas: "ABNT NBR 8522-2",
    sistema: passosSistema("ensaios de módulo de elasticidade"),
    execucao: [
      passoExecucao("modulo-dinamico", 0, "Preparação do corpo de prova", "Inspecione, meça e condicione o corpo de prova; confirme apoios e orientação do método adotado."),
      passoExecucao("modulo-dinamico", 1, "Montagem dos sensores", "Posicione apoios, sensor e ponto de excitação conforme o modo de vibração selecionado."),
      passoExecucao("modulo-dinamico", 2, "Aquisição das frequências", "Aplique impactos reproduzíveis, obtenha a frequência natural e descarte leituras instáveis."),
      passoExecucao("modulo-dinamico", 3, "Cálculo e registro", "Calcule o módulo com geometria, massa e frequência medidas e registre configuração, leituras e resultado."),
    ],
  },
  {
    id: "dosagem",
    teste: /^\/app\/(?:cadastro-dosagem|guias-dosagem|relatorios\/dosagem)(?:\/|$)/,
    titulo: "Dosagem e preparação de concreto em laboratório",
    normas: "ABNT NBR 12821, NBR 16887, NBR 5738 e NBR 5739",
    sistema: passosSistema("dosagens de concreto"),
    execucao: [
      passoExecucao("dosagem", 0, "Caracterização e pesagem", "Confirme materiais, umidades e massas previstas antes de iniciar a mistura."),
      passoExecucao("dosagem", 1, "Sequência de mistura", "Carregue o misturador conforme o procedimento, controle tempos e registre adições de água ou aditivo."),
      passoExecucao("dosagem", 2, "Ensaios no concreto fresco", "Determine consistência e, quando aplicável, teor de ar, temperatura e massa específica."),
      passoExecucao("dosagem", 3, "Moldagem e cura", "Molde, identifique e cure os corpos de prova destinados à validação do traço."),
      passoExecucao("dosagem", 4, "Resistência e curva de dosagem", "Realize as rupturas previstas, valide os resultados e construa as relações de dosagem."),
    ],
  },
  {
    id: "caracterizacao-agregados",
    teste: /^\/app\/(?:cadastro-caracterizacao(?:-miudo)?|relatorios\/caracterizacao)(?:\/|$)/,
    titulo: "Caracterização de agregados",
    normas: "ABNT NBR 17054, NBR 16916/16917, NBR 16972, NBR 16973, NBR 16974 e NBR 7809",
    sistema: passosSistema("caracterizações de agregados"),
    execucao: [
      passoExecucao("agregados", 0, "Composição granulométrica", "Prepare a amostra seca, selecione a série de peneiras, peneire até separação adequada e determine massas retidas e porcentagens."),
      passoExecucao("agregados", 1, "Densidade e absorção", "Condicione a amostra, obtenha as massas previstas pelo método aplicável e calcule densidade e absorção."),
      passoExecucao("agregados", 2, "Massa unitária e vazios", "Determine o volume do recipiente, encha pelo procedimento solto ou compactado, rase, pese e calcule massa unitária e índice de vazios."),
      passoExecucao("agregados", 3, "Material fino por lavagem", "Lave a amostra sobre as peneiras especificadas até a água ficar limpa, seque o material retido e determine a perda de massa."),
      passoExecucao("agregados", 4, "Abrasão Los Angeles", "Prepare a graduação, aplique a carga abrasiva e o número de revoluções previstos, peneire e determine a perda percentual."),
      passoExecucao("agregados", 5, "Índice de forma", "Selecione a amostra representativa, meça dimensões das partículas com paquímetro e calcule o índice segundo o método."),
      passoExecucao("agregados", 6, "Ensaios complementares do agregado miúdo", "Execute comparação colorimétrica de impurezas ou leitura das camadas no equivalente de areia conforme o ensaio selecionado."),
    ],
  },
  {
    id: "raa",
    teste: /^\/app\/ensaio-raa(?:\/|$)/,
    titulo: "Reatividade álcali-agregado — RAA",
    normas: "ABNT NBR 15577, com método conforme a parte selecionada",
    sistema: passosSistema("ensaios de RAA"),
    execucao: [
      passoExecucao("raa", 0, "Preparação dos materiais", "Separe agregado, cimento, solução e equipamentos. Utilize molde metálico com três cavidades longas para moldar três barras prismáticas por série."),
      passoExecucao("raa", 1, "Moldagem das barras", "Misture a argamassa, preencha as três cavidades do molde, adense conforme o procedimento e posicione os pinos de referência."),
      passoExecucao("raa", 2, "Cura e condicionamento", "Desmolde as três barras, faça a leitura inicial e mantenha-as na solução e temperatura controladas pelo método."),
      passoExecucao("raa", 3, "Leituras de expansão", "Limpe os pontos de contato, estabilize uma barra no comparador, faça leituras nas idades previstas e calcule a expansão."),
      passoExecucao("raa", 4, "Avaliação e relatório", "Revise as leituras das três barras, avalie a curva e o limite aplicável e registre a conclusão técnica."),
    ],
  },
  {
    id: "granulometria-asfalto",
    teste: /^\/app\/(?:granulometria-asfalto|relatorios\/mescla-granulometrica)(?:\/|$)/,
    titulo: "Granulometria e mescla para concreto asfáltico",
    normas: "DNIT 031/2024-ES e método de análise granulométrica aplicável",
    sistema: passosSistema("granulometrias e mesclas asfálticas"),
    execucao: [
      passoExecucao("mescla-asfaltica", 0, "Amostragem e preparação", "Separe amostras representativas de cada componente, seque e determine as massas iniciais."),
      passoExecucao("mescla-asfaltica", 1, "Peneiramento dos componentes", "Peneire cada material na série prevista, registre massas retidas e verifique o fechamento."),
      passoExecucao("mescla-asfaltica", 2, "Cálculo da mescla", "Aplique as proporções dos componentes para obter a curva combinada e compare-a com a faixa selecionada."),
      passoExecucao("mescla-asfaltica", 3, "Ajuste e relatório", "Ajuste percentuais quando necessário, confirme o total da mistura e documente curva, faixa e composição final."),
    ],
  },
  {
    id: "compactacao-solos",
    teste: /^\/app\/ensaio-compactacao(?:\/|$)/,
    titulo: "Compactação e caracterização de solos",
    normas: "ABNT NBR 7182, NBR 9895, NBR 7181, NBR 6459 e NBR 7180",
    sistema: passosSistema("ensaios de compactação e solos"),
    execucao: [
      passoExecucao("solos", 0, "Preparação da amostra", "Receba, seque conforme aplicável, desagregue sem quebrar partículas, quarteie e separe a fração prevista para cada ensaio."),
      passoExecucao("solos", 1, "Compactação", "Adicione água, homogeneíze, compacte as camadas com energia e molde definidos e determine massa úmida e teor de umidade."),
      passoExecucao("solos", 1, "Curva de compactação", "Repita para diferentes umidades, calcule massa específica seca e determine umidade ótima e massa específica seca máxima."),
      passoExecucao("solos", 2, "Expansão do corpo de prova CBR", "Instale disco perfurado, sobrecargas e extensômetro, mantenha o corpo de prova imerso e registre leituras de expansão."),
      passoExecucao("solos", 3, "Penetração CBR", "Posicione o molde na prensa, aplique assentamento e penetração controlada e registre cargas nos deslocamentos previstos."),
      passoExecucao("solos", 4, "Granulometria de solos", "Execute peneiramento e, quando necessário, sedimentação com dispersante, controlando tempo e temperatura das leituras."),
      passoExecucao("solos", 5, "Limite de liquidez", "Prepare a pasta, abra a ranhura padronizada, conte golpes até o fechamento e determine umidades para a curva de fluxo."),
      passoExecucao("solos", 6, "Limite de plasticidade", "Role porções sobre placa até formar fios no diâmetro especificado e determine a umidade no início da fragmentação."),
    ],
  },
  {
    id: "densidade-in-situ",
    teste: /^\/app\/densidade-in-situ(?:\/|$)/,
    titulo: "Densidade e grau de compactação in situ",
    normas: "Método de densidade in situ aplicável, incluindo ABNT NBR 7185 quando selecionado",
    sistema: passosSistema("determinações de densidade in situ"),
    execucao: [
      passoExecucao("solos", 7, "Calibração do conjunto", "Determine massa específica da areia e correção do funil usando recipiente calibrado e areia seca uniforme."),
      passoExecucao("solos", 7, "Preparação do ponto", "Nivele a superfície, assente a placa e execute o furo preservando todo o solo escavado."),
      passoExecucao("solos", 7, "Determinação do volume", "Instale o frasco, libere a areia até estabilização e determine a massa usada no furo após descontar o funil."),
      passoExecucao("solos", 7, "Umidade e massa específica", "Pese o solo retirado, determine umidade e calcule massas específicas úmida e seca."),
      passoExecucao("solos", 1, "Grau de compactação", "Compare a massa específica seca de campo com a máxima de laboratório correspondente e registre localização e resultado."),
    ],
  },
  {
    id: "ruptura-paver",
    teste: /^\/app\/ruptura-paver(?:\/|$)/,
    titulo: "Ensaios em peças de concreto para pavimentação",
    normas: "ABNT NBR 9781",
    sistema: passosSistema("ensaios de pavers"),
    execucao: [
      passoExecucao("paver", 0, "Amostragem e identificação", "Selecione e identifique as peças do lote, registre tipo, formato, idade, condição e eventuais defeitos."),
      passoExecucao("paver", 1, "Inspeção e dimensões", "Meça dimensões e verifique aspecto, tolerâncias e requisitos geométricos aplicáveis."),
      passoExecucao("paver", 2, "Condicionamento e absorção", "Prepare e condicione as peças conforme o ensaio selecionado, registrando as massas previstas para o cálculo."),
      passoExecucao("paver", 3, "Resistência mecânica", "Prepare as superfícies, posicione a peça e os dispositivos de carga e aplique carregamento contínuo até ruptura."),
      passoExecucao("paver", 4, "Resultado e lote", "Calcule resultados individuais e característicos, registre ruptura e avalie o lote segundo o requisito aplicável."),
    ],
  },
  {
    id: "ruptura-bloco-ceramico",
    teste: /^\/app\/ruptura-bloco-ceramico(?:\/|$)/,
    titulo: "Ensaios em blocos e tijolos cerâmicos",
    normas: "ABNT NBR 15270-1:2023 e NBR 15270-2:2023",
    sistema: passosSistema("ensaios de blocos cerâmicos"),
    execucao: [
      passoExecucao("bloco-ceramico", 0, "Amostragem e inspeção", "Identifique o lote, selecione as unidades e registre características visuais e geométricas."),
      passoExecucao("bloco-ceramico", 1, "Dimensões e áreas", "Determine dimensões, espessuras, desvio de esquadro, planeza e áreas previstas pelo método."),
      passoExecucao("bloco-ceramico", 2, "Absorção de água", "Seque, resfrie, pese, imerja e determine a massa saturada conforme os tempos e condições do método."),
      passoExecucao("bloco-ceramico", 3, "Preparo para compressão", "Regularize as faces de carregamento e condicione o corpo de prova antes do ensaio."),
      passoExecucao("bloco-ceramico", 4, "Compressão e classificação", "Centralize o bloco, aplique carga controlada até ruptura e avalie resistência e demais requisitos do lote."),
    ],
  },
  {
    id: "aderencia-tracao",
    teste: /^\/app\/resistencia-tracao(?:\/|$)/,
    titulo: "Resistência de aderência à tração de revestimentos",
    normas: "ABNT NBR 13528 e requisitos da ABNT NBR 13749 quando aplicáveis",
    sistema: passosSistema("ensaios de aderência à tração"),
    execucao: [
      passoExecucao("aderencia-tracao", 0, "Definição dos pontos", "Distribua os pontos de ensaio, identifique condições do revestimento e registre localização e idade."),
      passoExecucao("aderencia-tracao", 1, "Corte do corpo de prova", "Execute corte circular perpendicular atravessando o revestimento até o substrato, sem impactos ou danos laterais."),
      passoExecucao("aderencia-tracao", 2, "Colagem da pastilha", "Limpe e seque a superfície, cole a pastilha metálica centralizada e respeite a cura do adesivo."),
      passoExecucao("aderencia-tracao", 3, "Aplicação da tração", "Acople o equipamento alinhado, aplique carga perpendicular e uniforme e registre a força máxima."),
      passoExecucao("aderencia-tracao", 4, "Cálculo e forma de ruptura", "Calcule a tensão pela área efetiva e classifique percentualmente a interface ou material onde ocorreu a ruptura."),
    ],
  },
  {
    id: "adesividade-ligante",
    teste: /^\/app\/(?:adesividade-ligante-betuminoso|relatorios\/adesividade-ligante-betuminoso)(?:\/|$)/,
    titulo: "Adesividade de agregado graúdo ao ligante asfáltico",
    normas: "DNIT 452/2024-ME",
    sistema: passosSistema("ensaios de adesividade"),
    execucao: [
      passoExecucao("adesividade-ligante", 0, "Preparação do agregado", "Selecione a fração prevista, lave, seque e condicione uma amostra representativa."),
      passoExecucao("adesividade-ligante", 1, "Preparação do ligante", "Aqueça o ligante dentro da faixa de trabalho e evite superaquecimento ou contaminação."),
      passoExecucao("adesividade-ligante", 2, "Recobrimento", "Misture agregado e ligante até obter filme uniforme em todas as partículas."),
      passoExecucao("adesividade-ligante", 3, "Condicionamento", "Submeta a amostra recoberta à água e às condições de tempo e temperatura previstas no método."),
      passoExecucao("adesividade-ligante", 4, "Avaliação visual", "Compare partículas antes e depois, estime a área recoberta e registre perda de película e conclusão."),
    ],
  },
  {
    id: "calibracao-prensa-concreto",
    teste: /^\/app\/calibracao-prensa(?:\/|$)/,
    titulo: "Verificação de máquinas de ensaio de concreto",
    normas: "ABNT NBR ISO 7500-1:2023 e ABNT NBR ISO 376",
    sistema: passosSistema("calibrações de prensas"),
    execucao: [
      passoExecucao("calibracao-prensa", 0, "Inspeção e preparação", "Verifique identificação, capacidade, alinhamento, pratos, funcionamento e condições ambientais."),
      passoExecucao("calibracao-prensa", 1, "Instrumento de referência", "Instale transdutor ou padrão de força rastreável, centralizado e compatível com a faixa."),
      passoExecucao("calibracao-prensa", 2, "Pré-carregamento", "Aplique ciclos preliminares para assentamento e estabilização do conjunto."),
      passoExecucao("calibracao-prensa", 3, "Séries de medição", "Aplique forças crescentes nas faixas definidas e registre indicações da máquina e do padrão."),
      passoExecucao("calibracao-prensa", 4, "Erros e classificação", "Calcule erro relativo, repetibilidade, reversibilidade quando aplicável e registre classe e faixa aprovada."),
    ],
  },
  {
    id: "calibracao-prensa-solos",
    teste: /^\/app\/calibracao-prensa-solos(?:\/|$)/,
    titulo: "Verificação de prensas de solos e CBR",
    normas: "Procedimento metrológico aplicável e instrumentos rastreáveis",
    sistema: passosSistema("calibrações de prensas de solos"),
    execucao: [
      passoExecucao("calibracao-prensa-solos", 0, "Inspeção do sistema", "Verifique estrutura, alinhamento, pistão, curso, velocidade, indicadores e dispositivos de segurança."),
      passoExecucao("calibracao-prensa-solos", 1, "Montagem dos padrões", "Instale célula de carga e padrões de deslocamento rastreáveis na posição de trabalho."),
      passoExecucao("calibracao-prensa-solos", 2, "Verificação de força", "Aplique pontos crescentes e decrescentes na faixa de uso e registre padrão e indicação."),
      passoExecucao("calibracao-prensa-solos", 3, "Verificação de deslocamento", "Compare curso e velocidade de penetração com o padrão de deslocamento e tempo."),
      passoExecucao("calibracao-prensa-solos", 4, "Avaliação e certificado", "Calcule erros, declare faixa aprovada e registre padrões, condições, incerteza e rastreabilidade."),
    ],
  },
  {
    id: "tanque-cura",
    teste: /^\/app\/controle-temperatura-tanque-cura(?:\/|$)/,
    titulo: "Controle de temperatura do tanque de cura",
    normas: "ABNT NBR 9479 e requisitos de cura dos métodos associados",
    sistema: passosSistema("controles de temperatura do tanque"),
    execucao: [
      passoExecucao("tanque-cura", 0, "Inspeção do tanque", "Verifique limpeza, nível, circulação, espaçamento dos corpos de prova e funcionamento do controle."),
      passoExecucao("tanque-cura", 1, "Instrumento de referência", "Use termômetro calibrado e posicione o sensor em ponto representativo sem contato inadequado."),
      passoExecucao("tanque-cura", 2, "Leituras de temperatura", "Registre nos horários previstos e verifique uniformidade em diferentes regiões quando aplicável."),
      passoExecucao("tanque-cura", 3, "Tratamento de desvios", "Ao encontrar temperatura fora do limite, registre duração, ação corretiva e amostras potencialmente afetadas."),
      passoExecucao("tanque-cura", 4, "Registros e rastreabilidade", "Mantenha identificação do tanque, instrumento, calibração, operador, horários e resultados."),
    ],
  },
];

const ETAPAS_SISTEMA_PSICOSSOCIAL = [
  {
    preview: "psicossocial:0",
    titulo: "Lista de gestão psicossocial",
    descricao: "Consulte os colaboradores vinculados às empresas, filtre a lista e acompanhe quem ainda está pendente, quem já respondeu e quem está inativo.",
    dicas: [
      "Use o filtro Empresa para trabalhar apenas com os colaboradores de uma organização.",
      "Confira setor, função, celular e status antes de enviar os links.",
    ],
  },
  {
    preview: "psicossocial:1",
    titulo: "Cadastre o colaborador",
    descricao: "Clique em Novo colaborador, selecione a empresa e informe os dados de identificação, setor, função e celular usados para gerar o acesso individual.",
    dicas: [
      "Cadastre novos setores e funções pelos botões de adição quando necessário.",
      "Revise o celular antes de salvar para que o envio pelo WhatsApp seja direcionado corretamente.",
    ],
  },
  {
    preview: "psicossocial:2",
    titulo: "Envie o link individual",
    descricao: "Na coluna Link, copie o endereço individual ou abra o WhatsApp com a mensagem preparada. O link fica disponível enquanto o cadastro estiver pendente e ativo.",
    dicas: [
      "Cada colaborador deve receber somente o próprio link.",
      "Também é possível usar Enviar para todos para trabalhar com os pendentes da empresa filtrada.",
    ],
  },
  {
    preview: "psicossocial:3",
    titulo: "Acompanhe respostas e resultados",
    descricao: "Acompanhe a mudança do status de Pendente para Respondido e use Resultados para consultar a consolidação da pesquisa psicossocial da empresa.",
    dicas: [
      "Use Editar para corrigir o cadastro ou inativar um acesso que não deve mais ser utilizado.",
      "Confirme a empresa selecionada antes de abrir os resultados consolidados.",
    ],
  },
];

catalogo.push({
  id: "psicossocial",
  teste: /^\/admin\/psicossocial(?:\/|$)/,
  titulo: "Gestão psicossocial",
  normas: "",
  sistema: ETAPAS_SISTEMA_PSICOSSOCIAL,
  execucao: [],
});

const cadastrosSomenteSistema = [
  ["sgq", /^\/sgq(?:\/|$)/, "Sistema de Gestão da Qualidade"],
  ["admin-sgq", /^\/admin-sgq(?:\/|$)/, "Administração do SGQ"],
  ["lista-mestra", /^\/Lista-Mestra(?:\/|$)/, "Lista Mestra"],
  ["kpis", /^\/admin\/kpis(?:\/|$)/, "Indicadores e formulários"],
  ["equipamentos", /^\/app\/cadastro-equipamento(?:s|\/|$)/, "Cadastro de equipamentos"],
  ["ocorrencias", /^(?:\/app)?\/ocorrencias(?:\/|$)/, "Ocorrências"],
  ["pesquisas", /^\/app\/pesquisa(?:\/|$)/, "Pesquisas e inspeções"],
  ["usuarios", /^\/app\/cadastrousuarios(?:\/|$)/, "Cadastro de usuários"],
  ["laudos-admin", /^\/app\/cadastrarlaudos(?:\/|$)/, "Cadastro de laudos"],
  ["configuracoes", /^\/app\/configuracoes(?:\/|$)/, "Configurações técnicas"],
  ["concreteiras", /^\/app\/cadastro-concreteiras(?:\/|$)/, "Cadastro de concreteiras"],
  ["caixinha", /^\/app\/caixinha-empresa(?:\/|$)/, "Caixinha da empresa"],
  ["aprovacoes", /^\/app\/aprovacoes(?:\/|$)/, "Aprovações"],
  ["dp", /^(?:\/app\/departamento-pessoal|\/cadastro-funcionario)(?:\/|$)/, "Departamento pessoal"],
  ["etiquetas", /^\/app\/GerarEtiquetas(?:\/|$)/, "Geração de etiquetas"],
  ["solicitacoes", /^\/app\/solicitacao-servicos(?:\/|$)/, "Solicitações de serviços"],
  ["propostas", /^\/app\/proposta-comercial(?:\/|$)/, "Propostas comerciais"],
  ["visitas", /^\/app\/relatorios-visita-tecnica(?:\/|$)/, "Visitas técnicas"],
  ["rupturas-hoje", /^\/app\/rupturas-hoje(?:\/|$)/, "Rupturas do dia"],
].map(([id, teste, titulo]) => ({
  id,
  teste,
  titulo,
  normas: "",
  sistema: passosSistema(titulo.toLowerCase()),
  execucao: [],
}));

catalogo.push(...cadastrosSomenteSistema);

export function obterTutorialEnsaio(pathname = "") {
  return catalogo.find((item) => item.teste.test(pathname)) || null;
}

export { catalogo as CATALOGO_TUTORIAIS_ENSAIOS };
